import Vue from "vue";
import Router from "vue-router";
import Auth from "./auth";
import Main from "./main";
import store from "../store/store";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [Main, Auth, { path: "*", redirect: { name: "dashboard" } }]
});

router.beforeEach((to, from, next) => {
  if (!(to.meta.auth || false)) {
    return next();
  }

  if (!localStorage.getItem("authToken")) {
    return next({ name: "auth-login" });
  }

  if (!to.meta.perms) {
    return next();
  }

  if (to.meta.perms.length === 0) {
    return next();
  }

  for (let perm of to.meta.perms) {
    if (store.state.usuarios.usuarioAtivo.permissoes.includes(perm)) {
      return next();
    }
  }
  store.commit("ui/setSnackbar", {
    text: "Você não tem permissão de acessar esta funcionalidade do sistema."
  });
  return next(from);
});

export default router;
